
/**
 * BADGE DE TYPE D'ORDRE - Affiche un badge coloré selon le type d'ordre
 * @param {Object} props
 * @param {string} props.side - Type d'ordre (Buy/Sell/Souscription)
 */
const OrderTypeBadge = ({ side }) => {
  // Définition des styles pour chaque type avec Font Awesome
  const getBadgeStyles = (type) => {
    const styles = {
      Buy: {
        bg: 'success bg-opacity-10',
        text: 'text-success',
        border: 'border border-success border-opacity-25',
        icon: 'fas fa-arrow-down-circle',
        fallbackIcon: '↓',
        label: 'Achat'
      },
      Sell: {
        bg: 'danger bg-opacity-10', 
        text: 'text-danger',
        border: 'border border-danger border-opacity-25',
        icon: 'fas fa-arrow-up-circle',
        fallbackIcon: '↑',
        label: 'Vente'
      },
      Souscription: {
        bg: 'primary bg-opacity-10',
        text: 'text-primary',
        border: 'border border-primary border-opacity-25',
        icon: 'fas fa-file-circle-plus',
        fallbackIcon: '📄',
        label: 'Souscription'
      }
    };
    
    return styles[type] || styles.Buy;
  };

  const styles = getBadgeStyles(side);

  return (
    <span 
      className={`badge text-center rounded-pill ${styles.bg} ${styles.text} ${styles.border} d-flex align-items-center justify-content-center gap-2`}
      style={{ 
        minWidth: '120px',
        fontSize: '0.8rem',
        padding: '0.5rem 0.8rem',
        fontWeight: '500'
      }}
    >
      <i className={styles.icon} style={{ fontSize: '0.9rem' }}>
        <span style={{ fontSize: '0.7rem', display: 'none' }}>{styles.fallbackIcon}</span>
      </i>
      {styles.label}
    </span>
  );
};

export default OrderTypeBadge;